export const pt = {
  // Common
  common: {
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    search: 'Buscar',
    clear: 'Limpar',
    all: 'Todos',
    available: 'Disponíveis',
    sold: 'Vendidos',
    reserved: 'Reservados',
    occupied: 'Ocupados',
    total: 'Total',
    value: 'Valor',
    price: 'Preço',
    date: 'Data',
    lottery: 'Loteria',
    organizer: 'Organizador',
    processing: 'Processando...',
    ticketsSingular: 'bilhete',
    ticketsPlural: 'bilhetes',
    selectedSingular: 'selecionado',
    selectedPlural: 'selecionados'
  },

  // Raffle Page
  raffle: {
    loadingRaffle: 'Carregando rifa...',
    raffleNotFound: 'Rifa não encontrada',
    verifyLink: 'Verifique se o link está correto',
    errorLoading: 'Erro ao carregar a rifa',
    raffleNumber: 'Rifa #',
    drawDate: 'Data do Sorteio',
    noNumber: 'Sem número',
    showingSample: 'Mostrando uma amostra de bilhetes. Use a busca para encontrar números específicos.',
    showingSampleDesktop: 'Mostrando uma amostra aleatória de bilhetes. Use a busca para encontrar números específicos.'
  },

  // Ticket actions
  tickets: {
    searchTicket: 'Buscar número...',
    searchPlaceholder: 'Buscar número (ex: 42, 15, 73)',
    searchMultiple: 'Você pode buscar múltiplos números separando-os com vírgulas',
    multipleSelection: 'Seleção Múltipla',
    multipleSelectionActive: '✓ Seleção Múltipla',
    multipleSelectionActiveDesktop: '✓ Seleção Múltipla Ativa',
    activateMultipleSelection: 'Ativar Seleção Múltipla',
    randomNumbers: 'números',
    randomSelection: 'Na sorte',
    reserveAll: 'Reservar Todos',
    reserveSelected: 'Reservar Selecionados',
    clearSelection: 'Limpar',
    ticketOccupied: 'Este bilhete já está ocupado',
    noAvailableTickets: 'Não há bilhetes disponíveis',
    onlyAvailable: 'Apenas {count} bilhetes disponíveis',
    randomTicketsAdded: '{count} números aleatórios adicionados',
    noTicketsSelected: 'Você não selecionou nenhum bilhete',
    ticketsSelected: '{count} bilhetes selecionados',
    noResults: 'Nenhum bilhete encontrado',
    noResultsFor: 'Nenhum resultado encontrado para "{search}"',
    clearSearch: 'Limpar busca'
  },

  // Private Mode
  privateMode: {
    title: 'Modo Privado',
    description: 'Esta rifa está em modo privado. Busque seu número para verificar disponibilidade.',
    searchButton: 'Buscar meu número',
    searchNumbers: 'Buscar Números'
  },

  // Ticket Modal
  modal: {
    reserveTicket: 'Reservar Bilhete',
    reserveTickets: 'Reservar {count} Bilhetes',
    personalInfo: 'Informação Pessoal',
    fullName: 'Nome completo',
    phone: 'Telefone',
    email: 'Email',
    address: 'Endereço',
    specialNote: 'Enviar anotação especial',
    writeNote: 'Escreva sua anotação aqui...',
    confirmNote: 'Ao confirmar, o dono da rifa entrará em contato com você.',
    requiredFields: 'Por favor complete os campos obrigatórios',
    ticketReserved: 'Bilhete {number} reservado com sucesso!',
    ticketsReserved: '{count} bilhetes reservados com sucesso!',
    errorReserving: 'Erro ao reservar o bilhete. Por favor tente novamente.',
    errorReservingMultiple: 'Erro ao reservar os bilhetes. Por favor tente novamente.',
    selectedNumbers: 'Números selecionados:',
    totalValue: 'Valor total'
  },

  // Placeholders
  placeholders: {
    name: 'João Silva',
    phone: '(11) 98765-4321',
    email: 'email@exemplo.com',
    address: 'Rua 123, nº 45'
  },

  // Stats
  stats: {
    available: 'Disponíveis',
    reserved: 'Reservados',
    sold: 'Vendidos',
    occupied: 'Ocupados'
  },

  // Auth Pages
  auth: {
    login: {
      title: 'Entrar',
      or: 'Ou',
      createAccount: 'crie uma nova conta',
      email: 'E-mail',
      password: 'Senha',
      forgotPassword: 'Esqueceu sua senha?',
      loggingIn: 'Entrando...',
      loginButton: 'Entrar'
    },
    register: {
      title: 'Criar Conta',
      titleNew: 'Criar nova conta',
      or: 'Ou',
      haveAccount: 'já tem uma conta',
      loginIfHaveAccount: 'faça login se já tem uma conta',
      fullName: 'Nome completo',
      email: 'E-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      registering: 'Criando conta...',
      registerButton: 'Criar conta',
      passwordMismatch: 'As senhas não coincidem',
      accountType: 'Tipo de conta',
      userAccount: 'Usuário (Organizador de rifas)',
      vendorAccount: 'Vendedor',
      nameRequired: 'O nome é obrigatório',
      emailRequired: 'O e-mail é obrigatório',
      emailInvalid: 'E-mail inválido',
      passwordRequired: 'A senha é obrigatória',
      passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
      passwordPlaceholder: 'Mínimo 6 caracteres',
      repeatPassword: 'Repita a senha'
    },
    forgotPassword: {
      title: 'Recuperar Senha',
      description: 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
      email: 'E-mail',
      sending: 'Enviando...',
      sendButton: 'Enviar link',
      backToLogin: 'Voltar para login',
      success: 'Um link foi enviado para seu e-mail',
      error: 'Erro ao enviar link. Por favor, tente novamente.'
    }
  },

  // Error Pages
  errorPages: {
    notFound: {
      title: '404',
      subtitle: 'Página não encontrada',
      description: 'Desculpe, não conseguimos encontrar a página que você procura.',
      backHome: 'Voltar ao início'
    },
    unauthorized: {
      title: '401',
      subtitle: 'Não autorizado',
      description: 'Você não tem permissão para acessar esta página.',
      login: 'Entrar'
    }
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    welcome: 'Bem-vindo',
    myRaffles: 'Minhas Rifas',
    createRaffle: 'Criar Rifa',
    logout: 'Sair'
  }
};